<template>
	<v-col cols="12" lg="12" class="pb-0 pt-0">
		<v-card flat class="pb-0 pt-0">
			<v-card-text class="pb-0">
				<v-row class="d-flex justify-space-between">
					<v-col></v-col>
					<v-col class="pb-0 pt-0">
						<v-card-title class="d-flex justify-center align-center pa-2 pb-0 pt-0">{{
							$t('titles.statsOffices')
						}}</v-card-title>
					</v-col>
					<v-col></v-col>
				</v-row>
				<v-row>
					<v-col class="pt-0">
						<TheTable
							:additional-filters="statsOfficesTable.additionalFilters"
							:default-sort="statsOfficesTable.defaultSort"
							:excel="false"
							:fields="statsOfficesTable.headers"
							:header-selection-key="'stats-offices-headers'"
							:height="statsOfficesTable.height"
							:total-records="statsOfficesTable.total"
							:show-pagination="false"
							@headers="selectHeaders"
							@reload="reloadData"
						>
							<tr
								v-for="(item, key) in offices"
								:key="key"
								:class="{ 'bold-font': item.office == 'Ukupno' }"
							>
								<td v-if="statsOfficesTable.selectedHeaders.includes('office')">
									{{ item.office }}
								</td>
								<td
									style="text-align: right"
									v-if="statsOfficesTable.selectedHeaders.includes('courses')"
								>
									{{ item.courses }}
								</td>
								<td
									style="text-align: right"
									v-if="statsOfficesTable.selectedHeaders.includes('income')"
								>
									{{ item.income }}
								</td>
								<td
									style="text-align: right"
									v-if="statsOfficesTable.selectedHeaders.includes('discount')"
								>
									{{ item.discount }}
								</td>
								<td style="text-align: right" v-if="statsOfficesTable.selectedHeaders.includes('cost')">
									{{ item.cost }}
								</td>
								<td
									style="text-align: right"
									v-if="statsOfficesTable.selectedHeaders.includes('profit')"
								>
									{{ item.profit }}
								</td>
								<td
									style="text-align: right"
									v-if="statsOfficesTable.selectedHeaders.includes('registration')"
								>
									{{ item.registrations }}
								</td>
								<td
									style="text-align: right"
									v-if="statsOfficesTable.selectedHeaders.includes('income_candidate')"
								>
									{{ item.income_candidate }}
								</td>
								<td
									style="text-align: right"
									v-if="statsOfficesTable.selectedHeaders.includes('discount_candidate')"
								>
									{{ item.discount_candidate }}
								</td>
								<td
									style="text-align: right"
									v-if="statsOfficesTable.selectedHeaders.includes('cost_candidate')"
								>
									{{ item.cost_candidate }}
								</td>
								<td
									style="text-align: right"
									v-if="statsOfficesTable.selectedHeaders.includes('profit_candidate')"
								>
									{{ item.profit_candidate }}
								</td>
								<td
									style="text-align: right"
									v-if="statsOfficesTable.selectedHeaders.includes('income_percentage')"
								>
									{{ item.income_percentage }}
								</td>
								<td
									style="text-align: right"
									v-if="statsOfficesTable.selectedHeaders.includes('cost_percentage')"
								>
									{{ item.cost_percentage }}
								</td>
								<td
									style="text-align: right"
									v-if="statsOfficesTable.selectedHeaders.includes('profit_percentage')"
								>
									{{ item.profit_percentage }}
								</td>
								<td
									style="text-align: right"
									v-if="statsOfficesTable.selectedHeaders.includes('registrations_percentage')"
								>
									{{ item.registrations_percentage }}
								</td>
							</tr>
						</TheTable>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-col>
</template>

<script>
import TheTable from '../../trinkets/TheTable';
export default {
	name: 'Offices',
	components: { TheTable },
	data: function () {
		return {
			statsOfficesTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.office'),
						value: 'office',
						type: '',
						allowFilter: true,
						sortable: false,
					},
					{
						text: this.$t('fields.totalNumberOfCourses'),
						value: 'courses',
						type: '',
						allowFilter: true,
						alignRight: true,
						sortable: false,
					},
					{
						text: this.$t('fields.netIncome'),
						value: 'income',
						type: '',
						allowFilter: true,
						alignRight: true,
						sortable: false,
					},
					{
						text: this.$t('fields.netDiscount'),
						value: 'discount',
						type: '',
						allowFilter: true,
						alignRight: true,
						sortable: false,
					},
					{ text: this.$t('fields.cost'), value: 'cost', type: '', allowFilter: true, alignRight: true },
					{
						text: this.$t('fields.netProfit'),
						value: 'profit',
						type: '',
						allowFilter: true,
						alignRight: true,
						sortable: false,
					},
					{ text: this.$t('fields.registration'), value: 'registration', type: '', allowFilter: true },
					{
						text: this.$t('fields.incomeCandidate'),
						value: 'income_candidate',
						type: '',
						allowFilter: true,
						alignRight: true,
						sortable: false,
					},
					{
						text: this.$t('fields.discountCandidate'),
						value: 'discount_candidate',
						type: '',
						allowFilter: true,
						alignRight: true,
						sortable: false,
					},
					{
						text: this.$t('fields.costCandidate'),
						value: 'cost_candidate',
						type: '',
						allowFilter: true,
						alignRight: true,
						sortable: false,
					},
					{
						text: this.$t('fields.profitCandidate'),
						value: 'profit_candidate',
						type: '',
						allowFilter: true,
						alignRight: true,
						sortable: false,
					},
					{
						text: this.$t('fields.shareOfIncomeInTotalIncome'),
						value: 'income_percentage',
						type: '',
						allowFilter: true,
						alignRight: true,
						sortable: false,
					},
					{
						text: this.$t('fields.shareOfCostInTotalIncome'),
						value: 'cost_percentage',
						type: '',
						allowFilter: true,
						alignRight: true,
						sortable: false,
					},
					{
						text: this.$t('fields.shareOfProfitInTotalProfit'),
						value: 'profit_percentage',
						type: '',
						allowFilter: true,
						alignRight: true,
						sortable: false,
					},
					{
						text: this.$t('fields.shareOfNumberOfCandidatesInTotalNumberOfCandidates'),
						value: 'registrations_percentage',
						type: '',
						allowFilter: true,
						alignRight: true,
						sortable: false,
					},
				],
				additionalFilters: [],
				items: [],
				total: 5,
				lastRequest: null,
				height: '240px',
				defaultSort: {
					field: 'id',
					descending: true,
				},
			},
			coursesSum: 0,
			incomeSum: 0,
			costSum: 0,
			profitSum: 0,
			discountSum: 0,
			registrationSum: 0,
			incomeCandidateAvg: 0,
			costCandidateAvg: 0,
			discountCandidateAvg: 0,
			profitCandidateAvg: 0,
		};
	},
	props: {
		offices: {
			type: Array,
			required: true,
		},
	},
	methods: {
		selectHeaders(headers) {
			this.statsOfficesTable.selectedHeaders = headers;
		},
		reloadData() {
			this.statsOfficesTable.items = this.offices;
		},
	},
};
</script>

<style scoped>
.bold-font {
	font-weight: bold;
}
</style>
